<template>
  <!-- Popup Form -->
  <div v-if="showPopup" class="popup-overlay" @click.self="showPopup = false">
    <div class="popup-content" @click.stop>
      <button class="close" @click="showPopup = false">×</button>
      <h2 class="text-block-38">Get Your Free PDF</h2>
      <form @submit.prevent="submitForm">
        <div class="input-group">
          <input
            type="text"
            placeholder="First Name"
            v-model="firstName"
            required
          />
          <p v-if="submitted && !firstName" class="error">
            First name is required.
          </p>
        </div>
        <div class="input-group">
          <input
            type="text"
            placeholder="Last Name"
            v-model="lastName"
            required
          />
          <p v-if="submitted && !lastName" class="error">
            Last name is required.
          </p>
        </div>
        <div class="input-group">
          <input
            type="email"
            placeholder="Enter your email address"
            v-model="email"
            required
          />
          <p v-if="submitted && !email" class="error">
            Email is required.
          </p>
        </div>
        <div class="input-group">
          <input type="checkbox" id="privacyCheck" v-model="agreedToPrivacy" />
          <label class="text-block-57" for="privacyCheck"
            >I agree to how my data is used by the website in accordance with
            the
            <a href="https://thoth.art/privacy" target="_blank" class="link-6"
              >privacy policy</a
            >.</label
          >
        </div>
        <p v-if="submitted && !agreedToPrivacy" class="error">
          You must agree to the privacy policy.
        </p>
        <button type="submit" class="btn-submit ">SEND ME</button>
      </form>
    </div>
  </div>

  <div
    class="navbar w-nav"
    data-collapse="medium"
    data-animation="default"
    data-duration="400"
    data-doc-height="1"
    data-easing="ease"
    data-easing2="ease"
  >
    <div class="div-block-65">
      <div class="container">
        <router-link
          :to="`/${eventName}`"
          aria-current="page"
          class="brand w-nav-brand"
        >
          <img
            v-if="eventConfig && eventConfig.partnerLockup"
            :src="eventConfig.partnerLockup"
            alt="Event Logo"
            width="180"
            class="image-41"
          />
          <span v-else>Event Logo</span>
        </router-link>
        <div class="right_side_navbar">
          <nav role="navigation" class="nav-menu w-nav-menu">
            <router-link
              :to="{ path: `/${eventName}` }"
              :class="{
                'navlinks w-nav-link': true,
                'w--current': isActiveRoute(`/${eventName}`)
              }"
            >
              Highlights
            </router-link>

            <router-link
              :to="{ path: `/${eventName}/agenda` }"
              :class="{
                'navlinks w-nav-link': true,
                'w--current': isActiveRoute(`/${eventName}/agenda`)
              }"
            >
              Summaries
            </router-link>
            <router-link
              :to="{ path: `/${eventName}/about` }"
              :class="{
                'navlinks w-nav-link': true,
                'w--current': isActiveRoute(`/${eventName}/about`)
              }"
            >
              About
            </router-link>
          </nav>
          <div class="iconButtonParent">
            <router-link :to="`/${eventName}/likeinfographics`">
              <div class="iconButton">
                <img class="icon" alt="" src="../images/Like.svg" />
              </div>
            </router-link>
            <button
              class="mail-button w-button"
              id="pdfButton"
              @click="openTypeform"
            >
              <span> Get Compiled PDF </span>
              <img
                src="../images/download.svg"
                alt="PDF Icon"
                class="button-icon"
                style="margin-left: 4px;"
              />
            </button>
          </div>
        </div>

        <div class="menu-button w-nav-button" @click="toggleMobileMenu">
          <img
            src="../images/5f89831818dcb71775e1b3ea_hamburger-white.svg"
            width="30"
            alt=""
            class="image-15"
          />
        </div>
      </div>

      <!-- Mobile Menu Popup -->
      <div class="navbarmobile">
        <div class="leftHandPanel">
          <img class="logoIcon" alt="" :src="eventConfig.partnerLockup" />
        </div>
        <div class="links">
          <router-link
            :to="{ path: `/${eventName}` }"
            :class="
              isActiveRoute(`/${eventName}`) ? 'navigation' : 'navigation1'
            "
          >
            <div class="navigation3">Highlights</div>
          </router-link>
          <router-link
            :to="{ path: `/${eventName}/agenda` }"
            :class="
              isActiveRoute(`/${eventName}/agenda`)
                ? 'navigation'
                : 'navigation1'
            "
          >
            <div class="navigation3">Summaries</div>
          </router-link>
          <router-link
            :to="{ path: `/${eventName}/about` }"
            :class="
              isActiveRoute(`/${eventName}/about`)
                ? 'navigation'
                : 'navigation1'
            "
          >
            <div class="navigation3">About</div>
          </router-link>
          <router-link
            :to="{ path: `/${eventName}/likeinfographics` }"
            :class="
              isActiveRoute(`/${eventName}/likeinfographics`)
                ? 'navigation'
                : 'navigation1'
            "
          >
          <router-link :to="`/${eventName}/likeinfographics`">
              <div class="iconButton">
                <img class="icon" alt="" src="../images/Like.svg" />
              </div>
            </router-link>          </router-link>
          <button class="mail-button w-button" @click="openTypeform">
            Get Compiled PDF

              <img
                src="../images/download.svg"
                alt="PDF Icon"
                class="button-icon"
                style="margin-left: 4px;"
              />
          </button>
        </div>
      </div>
    </div>
    <a
      href="https://thoth.art/case-studies/neurips2024"
      target="_blank"
      v-if="eventName == 'aiewf2025'"
      class="cta_banner"
    >
      CHECK OUT OUR SUMMARIES ON NEURIPS 2024 HERE
    </a>
  </div>
</template>

<script>
import "toastr/build/toastr.min.css";

let typeformPopup = null;
let typeformScriptPromise = null;

function loadTypeformScript() {
  if (window.typeformEmbed) {
    console.log("Typeform embed already available");
    return Promise.resolve();
  }
  if (typeformScriptPromise) {
    console.log("Typeform script is already loading");
    return typeformScriptPromise;
  }
  console.log("Loading Typeform embed script...");
  typeformScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://embed.typeform.com/embed.js";
    script.onload = () => {
      console.log("Typeform script loaded");
      resolve();
    };
    script.onerror = e => {
      console.error("Typeform script failed to load", e);
      reject(e);
    };
    document.body.appendChild(script);
  });
  return typeformScriptPromise;
}
export default {
  inject: ["eventConfig"],
  computed: {
    eventName() {
      return this.$route.params.eventName || ""; // fallback to a default
    }
  },
  data() {
    return {
      isDropdownOpen: false, // State to manage dropdown visibility
      isMobileMenuOpen: false, // State to manage mobile menu popup
      showPopup: false,
      firstName: "",
      lastName: "",
      email: "",
      agreedToPrivacy: false,
      submitted: false,
      submitting: false
    };
  },
  methods: {
    isActiveRoute(routePath) {
      return this.$route.path === routePath;
    },
    toggleMobileMenu(event) {
      event.stopPropagation(); // Prevents the event from bubbling up to document
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      if (this.isMobileMenuOpen) {
        this.$nextTick(() => {
          document.addEventListener("click", this.handleClickOutside);
        });
      } else {
        document.removeEventListener("click", this.handleClickOutside);
      }
    },

    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.closeDropdown();
        this.isMobileMenuOpen = false; // Ensure the mobile menu is closed
        document.removeEventListener("click", this.handleClickOutside);
      }
    },

    openDropdown() {
      this.isDropdownOpen = true;
    },

    closeDropdown() {
      this.isDropdownOpen = false;
    },

    openTypeform() {
      console.log("openTypeform called");
      loadTypeformScript()
        .then(() => {
          console.log(
            "Typeform script ready, window.typeformEmbed:",
            !!window.typeformEmbed
          );
          if (window.typeformEmbed) {
            if (!typeformPopup) {
              console.log("Creating Typeform popup instance");
              typeformPopup = window.typeformEmbed.makePopup(
                "https://form.typeform.com/to/x77wbZ8g",
                {
                  mode: "popup",
                  autoClose: 3,
                  hideHeaders: true,
                  hideFooter: true
                }
              );
            }
            console.log("Opening Typeform popup");
            typeformPopup.open();
          } else {
            console.warn("Typeform embed not available, opening in new tab");
            window.open("https://form.typeform.com/to/x77wbZ8g", "_blank");
          }
        })
        .catch(e => {
          console.error(
            "Failed to load Typeform script, opening in new tab",
            e
          );
          window.open("https://form.typeform.com/to/x77wbZ8g", "_blank");
        });
    }
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  mounted() {
    // No need to load the script here; it will be loaded on demand
  }
};
</script>

<style scoped>
.cta_banner {
  width: 100%;
  background-color: var(--tertiary-color);
  color: black;
  padding: 10px 20px;
  border-radius: 5px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  font-family: "Libre Franklin";
  overflow: hidden;
  position: relative;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
}

.popup-content {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
  width: 90%;
  max-width: 400px;
}

.button-icon {
  width: 16px;
  /* Adjust size as needed */
  height: 16px;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}

.input-group {
  margin-bottom: 20px;
  position: relative;
  display: flex;
  gap: 10px;
}

.icon {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
}

.iconButton {
  width: 36px;
  border-radius: 12px;
  background-color: #363636;
  border: 1px solid #fff;
  box-sizing: border-box;
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 6px 0px;
}

.iconButtonParent {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  text-align: left;
  font-size: 16px;
  color: #fff;
  font-family: "DM Sans";
}

input[type="text"],
input[type="email"] {
  width: 100%;
  padding: 10px;
  border: 2px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  display: block;
}

input[type="text"]:focus,
input[type="email"]:focus {
  border-color: var(--primary-color);
}

.btn-submit {
  width: 100%;
  padding: 10px;
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.link-privacy {
  display: block;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
  color: #0066cc;
  text-decoration: none;
}

.link-privacy:hover {
  text-decoration: underline;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 50px;
  max-width: 100%;
  flex-wrap: nowrap;
}

.nav-menu {
  display: flex;
  gap: 20px;
  flex-wrap: nowrap;
}

.dropdown {
  position: relative;
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  z-index: 1000;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* padding: 10px; */
  display: flex;
  flex-direction: column;
}

.menu-button {
  cursor: pointer;
}

/* Mobile menu popup */
.mobile-menu-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mobile-menu-list {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 80%;
  max-width: 300px;
}

/* Animation for the mobile menu */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.navbarmobile {
  display: none;
}

/* Adjustments for responsiveness */
@media (max-width: 1024px) {
  .nav-menu {
    display: none;
  }

  .menu-button {
    display: block;
  }

  .logoIcon {
    /* width: 162.7px; */
    position: relative;
    height: 28px;
    overflow: hidden;
    flex-shrink: 0;
  }

  .leftHandPanel {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }

  .navigation1 {
    position: relative;
    line-height: 130%;
    font-weight: 400;
    text-decoration: none;
  }

  .navigation {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: var(--highlight-color);
    font-weight: 300;
    text-decoration: none;
  }

  .navigation3 {
    position: relative;
    line-height: 130%;
    white-space: nowrap;
  }

  .pdf {
    border: 1px solid white;
    padding: 12px 8px;
    border-radius: 12px;
  }

  .navigation2 {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0px 4px;
    white-space: nowrap;
  }

  .links {
    align-self: stretch;
    overflow-x: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 12px 0px;
    gap: 20px;
    white-space: nowrap;
  }

  .navbarmobile {
    width: 100%;
    position: absolute;
    margin: 0 !important;
    top: 0px;
    left: 0px;
    background-color: #111;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 24px 0px;
    box-sizing: border-box;
    gap: 12px;
    text-align: left;
    font-size: 16px;
    color: #fff;
    font-family: "DM Sans";
  }
}
</style>
